import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoaderService } from "@app/services/loader.service";

@Injectable()
export class NetworkInterceptor implements HttpInterceptor {
  private totalRequests = 0;
  private completedRequests = 0;

  constructor(private loadingService: LoaderService) {}

  intercept(
      request: HttpRequest<unknown>,
      next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    this.loadingService.setSpinnerVisibility(true);
    this.totalRequests++;

    return next.handle(request).pipe(
        finalize(() => {
          this.completedRequests++;
          if (this.completedRequests === this.totalRequests) {
            this.loadingService.setSpinnerVisibility(false);
            this.completedRequests = 0;
            this.totalRequests = 0;
          }
        })
    );
  }
}
